module.exports = __webpack_public_path__ + "static/img/1.25933a6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/3/1/1.png
// module id = mgwI
// module chunks = 0